export interface CompaniesRefreshFilterActionType {
  type: '@companies/REFRESH_FILTER';
}

export const refreshFilter = (): CompaniesRefreshFilterActionType => ({
  type: '@companies/REFRESH_FILTER',
});
